export function cadastroMarcaInRequest(params = {}) {
  return {
    type: '@cadastromarca/CADASTROMARCA_IN_REQUEST',
    payload: { params },
  };
}



export function findCadastroMarca(vemm_codigo) {
  return {
    type: '@cadastromarca/FIND_CADASTROMARCA',
    payload: { vemm_codigo },
  };
}

export function failedRequest() {
  return {
    type: '@cadastromarca/FAILED_REQUEST',
  };
}

export function deleteCadastroMarca(vemm_codigo, params) {
  return {
    type: '@cadastromarca/DELETE_CADASTROMARCA',
    payload: { vemm_codigo, params },
  };
}

export function updateCadastroMarca(cadastromarca, params) {
  return {
    type: '@cadastromarca/UPDATE_CADASTROMARCA',
    payload: { cadastromarca, params },
  };
}

export function storeCadastroMarca(cadastromarca, params) {
  return {
    type: '@cadastromarca/STORE_CADASTROMARCA',
    payload: { cadastromarca, params },
  };
}

export function successInRequest(
  cadastromarca,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@cadastromarca/SUCCESS_IN_REQUEST',
    payload: { cadastromarca, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(cadastromarca) {
  return {
    type: '@cadastromarca/SUCCESS_REQUEST',
    payload: { cadastromarca },
  };
}

export function successRemove(params) {
  return {
    type: '@cadastromarca/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@cadastromarca/RECORD_FILTERING',
    payload: { params },
  };
}
